import FeeRule from './fee_rule.vue';

export default FeeRule;
